var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "116px",
    height: "196px",
    viewBox: "0 0 116 196",
    enableBackground: "new 0 0 116 196",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 0.6374,
    x1: 0,
    y1: 159.4,
    x2: 98.8,
    y2: 159.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M102.7,160.8v-2.9h1.9v0.3H103v0.9h1.5v0.3H103v1.3H102.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M105,160.8v-2.9h0.4v2.5h1.3v0.3H105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M107.2,160.1c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.3,0.1-0.5,0.2-0.8c0.1-0.2,0.3-0.4,0.5-0.5 c0.2-0.1,0.5-0.2,0.7-0.2c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8c0,0.3-0.1,0.5-0.2,0.8 c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.2-0.7,0.2c-0.3,0-0.5-0.1-0.7-0.2C107.5,160.5,107.3,160.4,107.2,160.1z M107.4,159.4 c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.3,0.2,0.6,0.2s0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.4 c0.1-0.2,0.1-0.4,0.1-0.6c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3 C107.5,158.8,107.4,159,107.4,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M110.5,160.1c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.3,0.1-0.5,0.2-0.8c0.1-0.2,0.3-0.4,0.5-0.5 c0.2-0.1,0.5-0.2,0.7-0.2c0.3,0,0.5,0.1,0.7,0.2c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8c0,0.3-0.1,0.5-0.2,0.8 c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.2-0.7,0.2c-0.3,0-0.5-0.1-0.7-0.2C110.8,160.5,110.6,160.4,110.5,160.1z M110.7,159.4 c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.3,0.2,0.6,0.2s0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.4 c0.1-0.2,0.1-0.4,0.1-0.6c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3 C110.8,158.8,110.7,159,110.7,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M113.7,160.8v-2.9h1.2c0.3,0,0.5,0.1,0.7,0.2c0.2,0.2,0.3,0.4,0.3,0.6c0,0.1,0,0.2-0.1,0.3 c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.1,0.1-0.2,0.2s-0.2,0.1-0.3,0.1l0.8,1.2h-0.4l-0.7-1.1h-0.6v1.1H113.7z M114.1,159.4h0.8 c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.2-0.4s-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2h-0.8V159.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 59.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 0.6443,
    strokeMiterlimit: 10,
    width: 60.2,
    height: 83.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3,
    y: 64.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 0.6443,
    strokeMiterlimit: 10,
    width: 50.3,
    height: 73.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M100.7,37.1c-0.1-0.2-0.1-0.4-0.1-0.6s0-0.4,0.1-0.6c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.1,0.3-0.2,0.5-0.3 c0.2-0.1,0.4-0.1,0.6-0.1c0.5,0,0.8,0.2,1.1,0.6l-0.3,0.2c-0.1-0.1-0.2-0.2-0.3-0.3s-0.3-0.1-0.5-0.1c-0.3,0-0.6,0.1-0.8,0.3 c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.3,0,0.5-0.1 c0.1-0.1,0.3-0.2,0.3-0.3l0.3,0.2c-0.3,0.4-0.6,0.6-1.1,0.6c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.3-0.2-0.5-0.3 C100.9,37.4,100.8,37.3,100.7,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M103.6,37.9v-2.9h1.9v0.3H104v0.9h1.5v0.3H104v1h1.5v0.3H103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M106.1,37.9v-2.9h0.4v2.9H106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M107,37.9v-2.9h0.4v2.5h1.3v0.3H107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M109.2,37.9v-2.9h0.4v2.9H109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M110.2,37.9v-2.9h0.4l1.6,2.2v-2.2h0.4v2.9h-0.3l-1.7-2.3v2.3H110.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M113.3,37.1c-0.1-0.2-0.1-0.4-0.1-0.6s0-0.4,0.1-0.6c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.1,0.3-0.2,0.5-0.3 c0.2-0.1,0.4-0.1,0.6-0.1c0.5,0,0.8,0.2,1.1,0.5l-0.3,0.2c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.1-0.3-0.1-0.5-0.1 c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.2,0,0.4,0.1,0.6s0.2,0.3,0.4,0.4s0.4,0.1,0.6,0.1c0.2,0,0.3,0,0.4-0.1 c0.1-0.1,0.2-0.1,0.3-0.2v-0.6h-1v-0.3h1.3v1c-0.1,0.2-0.3,0.3-0.5,0.4s-0.4,0.1-0.6,0.1c-0.2,0-0.4,0-0.6-0.1 c-0.2-0.1-0.3-0.2-0.5-0.3C113.4,37.4,113.3,37.3,113.3,37.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 0.6886,
    x1: 89.2,
    y1: 45.2,
    x2: 9.7,
    y2: 45.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "88.6,43.1 92.1,45.2 88.6,47.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "10.3,43.1 6.7,45.2 10.3,47.2  "
  })))), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 0.6374,
    x1: 0,
    y1: 36.6,
    x2: 98.8,
    y2: 36.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 0.5646,
    x1: 92.1,
    y1: 40.7,
    x2: 92.1,
    y2: 49.6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 0.5646,
    x1: 6.7,
    y1: 40.7,
    x2: 6.7,
    y2: 49.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.7,
    y: 37.5,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.2707,
    width: 85.4,
    height: 2.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT1);
export default __webpack_public_path__ + "static/media/t1.6a98ae92cf77c0aa0db993fe3f596e3f.svg";
export { ForwardRef as ReactComponent };